import { useState } from "react";
import { getTrip, getTripDetails as bmsGetTripDetails, searchTrips as bmsSearchTrips } from '../bms'
import { useBmsAuth } from './useBmsAuth';

export const useSearchTrips = () => {
   const token = useBmsAuth()
   const [trips, setTrips] = useState([])
   const [selectedTrip, setSelectedTrip] = useState(null)
   const [loading, setLoading] = useState(false);
   const [error, setError] = useState('')


   const getTripDetails = async (id?: string) => {
      if (!id) {
         setSelectedTrip({})
         return;
      }
      setLoading(true);
      setTrips([]);
      const trip = await bmsGetTripDetails(id, token);
      setSelectedTrip(trip)
      setLoading(false);
      // plugin.setFieldValue(plugin.fieldPath, JSON.stringify(response));
   };

   const searchTrips = async (query: string) => {
      setError('')
      setTrips([])
      if (!query) {
         return;
      }
      setLoading(true)
      const isNumber = Number.isInteger(parseInt(query, 10));
      try {
         const responseTrips = []
         if (isNumber) {
            const trip = await getTrip(query)
            responseTrips.push(trip)
         } else {
            const activeTrips = await bmsSearchTrips({ status: 'active', name: query }, token);
            const draftTrips = await bmsSearchTrips({ status: 'draft', name: query }, token);
            activeTrips.forEach(trip => responseTrips.push(trip))
            draftTrips.forEach(trip => responseTrips.push(trip))
         }
         setTrips(responseTrips)
         if (responseTrips.length === 0) {
            const friendlyPropName = `${query[0].toUpperCase()}${query
               .slice(1)
               .replace(/_/gi, ' ')}`;
            setError(`${friendlyPropName} not found`);
         }
      } catch (error) {
         console.log(error)
         setError('Error requesting data.');
      }

      setLoading(false)
   }

   const reset = () => {
      setTrips([])
   }

   return { trips, searchTrips, getTripDetails, error, loading, selectedTrip, reset }
}